import cn from "classnames"

import { Button } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./ButtonsFilter.module.scss"

import type { ButtonsFilterProps } from "."

export const ButtonsFilter = (props: ButtonsFilterProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "filter" })
  const { clearDisabled, onClear, okDisabled, onOk, okHide = true } = props
  const showApply = !okHide

  return (
    <div className={cn(styles.container, showApply && styles.containerApply)}>
      <Button
        disabled={clearDisabled}
        size="small"
        type="text"
        onClick={onClear}
      >
        {t("clear")}
      </Button>
      {showApply && (
        <Button
          disabled={okDisabled}
          size="small"
          type="primary"
          onClick={onOk}
        >
          {t("apply")}
        </Button>
      )}
    </div>
  )
}
